import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import languages from 'assets/i18n/language-list.json'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

/**
 * This is the app component #compodoctesti
 */
export class AppComponent {

  constructor( private translate: TranslateService ) {

  }


  title = 'Solar';
  login = false;
  dashboard = true;
  languageList = languages;

  ngOnInit() {

    this.translate.setDefaultLang('en');
    this.translate.addLangs(this.languageList.languages)
    this.translate.use('en')
  }



}


